/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, WebAppGetFragmentSocialUploadsUploadByIdPathParams, WebAppGetFragmentSocialUploadsUploadById401, WebAppGetFragmentSocialUploadsUploadById403 } from "../models/WebAppGetFragmentSocialUploadsUploadById";

export function getWebAppGetFragmentSocialUploadsUploadByIdUrl(uploadId: WebAppGetFragmentSocialUploadsUploadByIdPathParams["uploadId"]) {
  const res = { method: 'GET', url: `/web-app/v1/fragment-social-uploads/${uploadId}` as const }
  return res
}

/**
 * @summary Get a single social upload by id
 * {@link /web-app/v1/fragment-social-uploads/:uploadId}
 */
export async function webAppGetFragmentSocialUploadsUploadById(uploadId: WebAppGetFragmentSocialUploadsUploadByIdPathParams["uploadId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentSocialUploadsUploadById401 | WebAppGetFragmentSocialUploadsUploadById403>, unknown>({ method : "GET", url : getWebAppGetFragmentSocialUploadsUploadByIdUrl(uploadId).url.toString(), ... requestConfig })
  return res.data
}